import React from 'react'
import {
  Settings, CreditCard, Users, UserCog, Home, LayoutDashboard, LucideProps, Bell, Book, Bookmark, Box, Briefcase,
  ChartBar, CheckCircle, ChevronRight, ClipboardList, Cloud, Cpu, Database, Eye, FileText, Flag, Gift, Globe, Grid,
  Inbox, Key, Layers, LifeBuoy, Link, List, Lock, Mail, Map, MessageCircle, MessageSquare, Package, Phone, PieChart, Rocket,
  Search, Server, Shield, ShoppingCart, Star, Tag, Terminal, Timer, TrendingUp, Upload, User, Wrench
} from 'lucide-react'

export type IconId = keyof typeof ICONS

export const ICONS: Record<string, React.FC<LucideProps>> = {
  settings: Settings,
  'credit-card': CreditCard,
  users: Users,
  'user-cog': UserCog,
  home: Home,
  dashboard: LayoutDashboard,
  bell: Bell,
  book: Book,
  bookmark: Bookmark,
  box: Box,
  briefcase: Briefcase,
  'chart-bar': ChartBar,
  'check-circle': CheckCircle,
  'chevron-right': ChevronRight,
  'clipboard-list': ClipboardList,
  cloud: Cloud,
  cpu: Cpu,
  database: Database,
  'file-text': FileText,
  flag: Flag,
  gift: Gift,
  globe: Globe,
  grid: Grid,
  eye: Eye,
  inbox: Inbox,
  key: Key,
  layers: Layers,
  'life-buoy': LifeBuoy,
  link: Link,
  list: List,
  lock: Lock,
  mail: Mail,
  map: Map,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  package: Package,
  phone: Phone,
  'pie-chart': PieChart,
  rocket: Rocket,
  search: Search,
  server: Server,
  shield: Shield,
  'shopping-cart': ShoppingCart,
  star: Star,
  tag: Tag,
  terminal: Terminal,
  timer: Timer,
  'trending-up': TrendingUp,
  upload: Upload,
  user: User,
  wrench: Wrench,
}

export function IconById({ id, className }: { id: IconId; className?: string }) {
  const Cmp = (ICONS as any)[id] || Settings
  return <Cmp className={className} />
}

